import axios from "axios";
import { mapGetters } from "vuex";
import CONFIG from "@/assets/js/config.js";
import pdfIcon from '@/assets/images/pdf.png';
import docIcon from '@/assets/images/icon-doc.png';
import pptIcon from '@/assets/images/icon-ppt.png';
import pngIcon from '@/assets/images/icon-png.png';
import jpgIcon from '@/assets/images/icon-jpg.png';

export default {
  props: {
    answerId: Number
  },

  data() {
    return {
      answer: {},
      errors: {
        remark: null
      },
      disabled: false,
      CONFIG,
      pdfIcon,
      docIcon,
      pptIcon,
      pngIcon,
      jpgIcon
    };
  },

  computed: {
    ...mapGetters(["teacherId", "schoolId", "studentId", "userType"]),
  },

  methods: {
    hasRemark() {
      const remark = this.answer.remark;
      return remark !== null && remark !== undefined && remark.trim() !== "";
    },

    updateAnswerRemark(answerId) {
      const remarkText = this.answer.remark || "";

      if (remarkText.length > 5000) {
        this.errors.remark = "ဖြေဆိုမှုမှတ်ချက်သည် စာလုံးရေ ၅၀၀၀ ထက်မကျော်ရပါ။";
        return Promise.reject(new Error(this.errors.remark));
      } else {
        this.errors.remark = null;
      }

      return this.axios.post(`my/assignment/answer/update-remark/${answerId}`, {
        remark: remarkText
      })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.log("Update Remark Error", error);
          throw error;
        });
    },


    answerDetail() {
      axios.get("my/assignment/answer/detail/" + this.answerId)
        .then(response => {
          this.answer = response.data;
          this.answer.assignment_files.forEach(file => {
            const parts = file.path.split('.');
            file.type = parts.length ? parts.pop().toLowerCase() : '';
          });
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log("Assignment Detail API Error:", error);
        });
    },

    answerList() {
      this.$emit('changeSection', 'AssignmentAnswerList');
    },

    rejectAnswer(answerId) {
      if (this.disabled) return;
      this.disabled = true;

      let promise;

      if (this.hasRemark()) {
        promise = this.updateAnswerRemark(answerId);
      } else {
        promise = Promise.resolve();
      }

      promise
        .then(() => {
          return this.axios.delete(`my/assignment/answer/reject/${answerId}`);
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notification.success("Assignment ပယ်ဖျက်ခြင်းအောင်မြင်ပါသည်။", {
              timer: 3, position: "bottomCenter"
            });
            this.answerList();
          } else {
            this.$notification.error("Assignment ပယ်ဖျက်ခြင်းမအောင်မြင်ပါ။");
          }
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log("Reject Error", error);
        })
        .finally(() => {
          this.disabled = false;
        });
    },

    approveAnswer(answerId) {
      if (this.disabled) return;
      this.disabled = true;

      let promise;

      if (this.hasRemark()) {
        promise = this.updateAnswerRemark(answerId);
      } else {
        promise = Promise.resolve();
      }

      promise
        .then(() => {
          return this.axios.post(`my/assignment/answer/approve/${answerId}`);
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notification.success("Assignment လက်ခံခြင်းအောင်မြင်ပါသည်။", {
              timer: 3, position: "bottomCenter"
            });
            this.answerList();
          } else {
            this.$notification.error("Assignment လက်ခံခြင်းမအောင်မြင်ပါ။");
          }
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log("Approve Error", error);
        })
        .finally(() => {
          this.disabled = false;
        });
    },

    async download(index) {
      var file = this.answer.assignment_files[index];
      try {
        const response = await axios.get(`/my/assignment/answer/download/${this.answerId}/${file.file_code}`, {
          responseType: "blob",
        });

        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = file.name;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        this.$notification.error("Download Failed.", {
          timer: 3,
          position: "bottomCenter",
        });
      }
    }
  },

  mounted() {
    this.answerDetail();
  }
};
